module.exports = __webpack_public_path__ + "static/media/Logo.0ee5f378.svg";